import { gql, useQuery } from '@apollo/client';
import {
  GetPhotosQuery,
  GetPhotosQueryVariables,
} from '../../__generated__/queries-photo';

export const GET_PHOTOS = gql`
  query GetPhotos(
    $where: PhotoWhereInput
    $first: Int!
    $orderBy: [PhotoOrderByInput!]
    $skip: Int
  ) {
    photoCount: searchPhotosCount(where: $where)
    photos: searchPhotos(
      where: $where
      first: $first
      orderBy: $orderBy
      skip: $skip
    ) {
      id
      archive {
        id
      }
      createdAt
      isUploaded
      isLegacy
      originalName
      publicUrl
      photoMetadatas(first: 1000) {
        id
        value
        metadata {
          id
          name
        }
      }
      previews {
        size
        href
      }
    }
  }
`;

export const useGetPhotos = (
  variables: GetPhotosQueryVariables,
  skip = false,
) =>
  useQuery<GetPhotosQuery, GetPhotosQueryVariables>(GET_PHOTOS, {
    fetchPolicy: 'network-only',
    skip,
    variables,
  });
